export default "__VITE_ASSET__09299763__"